import { Box, Typography } from '@astro-ui/components'
import { dsColor } from '@astro-ui/fondations/colors/colors'

type TagVariantType = 'default' | 'info' | 'warning' | 'purple' | 'success' | 'danger'

type TagColorConfigType = {
  textColor: string
  bgColor: string
  borderColor: string
}

const TAG_VARIANT_CONFIG: Record<TagVariantType, TagColorConfigType> = {
  default: {
    textColor: dsColor.neutral['neutral-10'],
    bgColor: dsColor.neutral['neutral-2'],
    borderColor: dsColor.neutral['neutral-3'],
  },
  info: {
    textColor: dsColor.qd.cyan['cy-14'],
    bgColor: dsColor.qd.cyan['cy-2'],
    borderColor: dsColor.qd.cyan['cy-4'],
  },
  warning: {
    textColor: dsColor.sys.orange['or-13'],
    bgColor: dsColor.sys.orange['or-1'],
    borderColor: dsColor.sys.orange['or-2'],
  },
  purple: {
    textColor: dsColor.qd.purple['pu-13'],
    bgColor: dsColor.qd.purple['pr-1'],
    borderColor: dsColor.qd.purple['pr-2'],
  },
  success: {
    textColor: dsColor.sys.green['gr-13'],
    bgColor: dsColor.sys.green['gr-1'],
    borderColor: dsColor.sys.green['gr-2'],
  },
  danger: {
    textColor: dsColor.nebula['nebula-13'],
    bgColor: dsColor.nebula['nebula-1'],
    borderColor: dsColor.nebula['nebula-2'],
  },
}

export type TagPropsType = {
  label: string
  variant?: TagVariantType
}

const Tag = ({ label, variant = 'default' }: TagPropsType) => {
  if (!label) return null

  const { textColor, bgColor, borderColor } = TAG_VARIANT_CONFIG[variant]

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      px="12px"
      py="4px"
      borderRadius="32px"
      border="1px solid"
      borderColor={borderColor}
      bg={bgColor}
      width="fit-content"
    >
      <Typography variant="body-tinyStrong" sx={{ color: textColor }} whiteSpace="nowrap">
        {label}
      </Typography>
    </Box>
  )
}

export default Tag
